class Menu {

    constructor() {
        /**
         * @type {HTMLElement}
         */
        this.burger = document.getElementById('toggle-nav-mobile');
        /**
         * @type {Element}
         */
        this.header = document.getElementsByTagName('header')[0];
        /**
         * @type {Element}
         */
        this.mainMenu = document.getElementById('main-menu');
        /**
         * @type {Element}
         */
        this.footer = document.querySelector('footer');
        /**
         * @type {number}
         */
        this.scrollPosition = window.scrollY || document.documentElement.scrollTop;
        /**
         * Init
         */
        this._init();
    }

    /**
     * Init
     * @private
     */
    _init() {
        this.burger.addEventListener('click', () => this.toggleMobile());
        document.addEventListener('scroll', () => this.scroll());
        // Init sticky
        if (this.scrollPosition > this.header.clientHeight) {
            this.mainMenu.classList.add('sticky');
        }
    }

    /**
     * Scroll
     */
    scroll() {
        this.scrollPosition = window.scrollY || document.documentElement.scrollTop;

        if (this.scrollPosition > this.header.clientHeight) {
            this.mainMenu.classList.add('sticky');
        } else {
            this.mainMenu.classList.remove('sticky');
        }
    }

    /**
     * Toggle
     */
    toggleMobile() {
        const MAIN_NAV = this.mainMenu.querySelector('nav');

        this.burger.classList.toggle('is-active');
        this.footer.classList.toggle('menu-mobile-active');

        if (MAIN_NAV.style.height) {
            MAIN_NAV.style.removeProperty('height');
            MAIN_NAV.style.removeProperty('width');
            document.body.style.removeProperty('overflow');
        } else {
            MAIN_NAV.style.height        = screen.height + 'px';
            MAIN_NAV.style.width         = screen.width + 'px';
            document.body.style.overflow = 'hidden';
        }
    }
}